module.exports = __webpack_public_path__ + "img/6.cba36098.jpg";